import { AppModule } from "./app/app.module"
import { environment } from "./environments/environment"
import { config } from "./config/config"

import { bootstrapApp } from "@puntaje/puntaje/core"

bootstrapApp("admin", environment, config, AppModule)
